module.exports = __webpack_public_path__ + "d88870e153ff96d61df8a61f15abd46d.png";